<template>
  <div class="table-wrapper">
    <table class="table">
      <thead class="header">
        <tr>
          <th class="sticky-col student-head-col"><span>Студент</span></th>
          <th
            v-for="quality in projectQualities"
            :key="quality.id"
            class="quality-head-col"
          >
            <span>{{ capitalize(quality.name) }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <students-table-item
          v-for="student in students"
          :key="student.userId"
          :student="student"
          :project-qualities="projectQualities"
          :disabled="disabled"
        />
      </tbody>
    </table>
  </div>
</template>

<script setup>
  import { useRoute } from 'vue-router';
  import { onMounted, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import StudentsTableItem from '@/views/leader/projects/students/components/StudentsTableItem.vue';

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const api = useApi();
  const route = useRoute();
  const projectQualities = ref([]);
  const students = ref([]);

  onMounted(async () => {
    await getProjectQualities();
    await getStudents();
  });

  const getProjectQualities = async () => {
    try {
      const response = await api.quality.index(
        new URLSearchParams({
          projectId: route.params.id,
        })
      );
      projectQualities.value = response.qualities.items;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getStudents = async () => {
    try {
      const response = await api.projectExecutor.students(
        new URLSearchParams({
          projectId: route.params.id,
        })
      );
      students.value = response.students.items;
    } catch (error) {
      console.error('error', error);
    }
  };

  function capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
  }
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;
  $color-text-secondary-grey-216: #718096;

  .table-wrapper {
    position: relative;
    overflow: auto;
    //border: 1px solid black;
    white-space: nowrap;
    width: 1130px;
  }

  .table {
    border-collapse: separate;
    border-spacing: 0 15px;
    padding-top: 30px;
    width: 100%;

    th[class*='col'] {
      span {
        border-bottom: 1px solid #f2f4f8;
        display: block;
        padding-bottom: 10px;
        width: 100%;
      }
    }

    th:first-child {
      padding-left: 0;
    }

    .header {
      border-bottom: 1px solid $color-bg-secondary-grey;
      color: $color-text-secondary-grey-216;
      font-variant-numeric: slashed-zero;
      font-family: Nunito Sans, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 10px;
      text-align: left;
    }

    .quality-head-col {
      padding: 0 20px;
      text-align: center;
    }

    .sticky-col {
      position: sticky;
      left: 0;
      z-index: 1;
      background: $color-bg-primary-white;
    }
  }
</style>
